




































































import Vue from 'vue'

export default Vue.extend({
	props: {
		url: {
			type: String,
			default: null,
		},
		title: {
			type: String,
			default: null,
		},
		text: {
			type: String,
			default: null,
		},
	},
	data() {
		return {
			invitationEmail: '',
			isSendingEmail: false,
			emailSent: false,
			showChatPopup: false,
		}
	},
	methods: {
		inviteByEmail() {
			if (!this.invitationEmail.length) {
				return
			}

			this.isSendingEmail = true

			this.$axios.put('/api/user/email-invitation', {
				email: this.invitationEmail,
				language: this.$i18n.locale,
			}).then(() => {
				this.emailSent = true
				this.invitationEmail = ''
			}).catch(() => {
				this.$nuxt.$emit('showToastMessage', {
					message: this.$t('error.unkown').toString(),
					duration: 3000,
				})
			}).finally(() => {
				this.isSendingEmail = false
			})
		},
		validEmail() {
			// eslint-disable-next-line max-len
			const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			return re.test(String(this.invitationEmail).toLowerCase())
		},
		whatsAppUrl(): string {
			if (!this.url) {
				return this.$t('shareUrls.whatsapp').toString()
			}

			return `whatsapp://send?text=${encodeURIComponent(this.text)}%0A${encodeURIComponent(this.url)}`
		},
		telegramUrl(): string {
			if (!this.url) {
				return this.$t('shareUrls.telegram').toString()
			}

			// eslint-disable-next-line max-len
			return `https://t.me/share/url?url=${encodeURIComponent(this.url)}&text=${encodeURIComponent(this.text)}`
		},
		linkedInUrl(): string {
			if (!this.url) {
				return this.$t('shareUrls.linkedIn').toString()
			}

			// eslint-disable-next-line max-len
			return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(this.url)}&title=${encodeURIComponent(this.title)}&summary=${encodeURIComponent(this.text)}&source=LinkedIn`
		},
	},
})
